import {Pipe} from "@angular/core";

@Pipe({name: 'momentDate'})
export class MomentDatePipe {
  transform(value: any, ): any {
    return value.format('DD.MM.YYYY HH:mm');
  }
}
